import {Action} from '@ngrx/store';
import {User} from '../../../models/user';

export class GetUsersSuccessAction implements Action {
  public static readonly type = 'GetUsersSuccessAction';

  constructor(public users: User[]) {
  }

  public type = GetUsersSuccessAction.type;
}
